import { useMemo } from 'react';

import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { LANDSCAPE_OR_DESKTOP_QUERY, TILE_GEOMETRY } from '../constants';

export interface TileGeometry {
  tileWidth: number;
  tileGap: number;
  stride: number;
  amountMaxWidth: number;
  amountMaxFont: number;
}

export function useTileGeometry(): TileGeometry {
  const isDesktop = useMediaQuery(LANDSCAPE_OR_DESKTOP_QUERY);

  return useMemo(() => {
    const { tileWidth, tileGap, amountMaxFont } = isDesktop ? TILE_GEOMETRY.desktop : TILE_GEOMETRY.mobile;
    return { tileWidth, tileGap, stride: tileWidth + tileGap, amountMaxWidth: tileWidth / 2, amountMaxFont };
  }, [isDesktop]);
}
